import { ApiRequestError } from './api-client';

const CSRF_RECOVERY_CODES = new Set([
  'CSRF_ORIGIN_MISSING',
  'CSRF_ORIGIN_INVALID',
  'CSRF_TOKEN_MISSING',
  'CSRF_TOKEN_EXPIRED',
  'CSRF_TOKEN_INVALID',
]);

export function isApiUnauthorized(err: unknown): boolean {
  return err instanceof ApiRequestError && err.status === 401;
}

export function isApiForbidden(err: unknown): boolean {
  return err instanceof ApiRequestError && err.status === 403;
}

/** User-facing copy when auth/CSRF state is stale (expired session, DB reset, etc.). */
export function getSessionRecoveryMessage(err: unknown): string | null {
  if (isApiUnauthorized(err)) {
    return 'Your session expired. Please log in again.';
  }
  if (
    err instanceof ApiRequestError &&
    err.status === 403 &&
    err.code &&
    CSRF_RECOVERY_CODES.has(err.code)
  ) {
    return 'Your session expired. Please refresh the page and log in again.';
  }
  return null;
}

/** Prefer API validation messages; fall back to a friendly default. */
export function getApiErrorMessage(err: unknown, fallback: string): string {
  const sessionMessage = getSessionRecoveryMessage(err);
  if (sessionMessage) return sessionMessage;
  if (err instanceof ApiRequestError) {
    const message = err.message.trim();
    if (message) return message;
  }
  if (err instanceof Error) {
    const message = err.message.trim();
    if (message && message !== 'Upload failed') return message;
  }
  return fallback;
}
